// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"a324a0c0","308":"6fe738e9"}[chunkId] + ".chunk.css";
};